import {createContext, useContext, useState} from 'react'
import {AuthModel, UserModel} from './_models'
import {getAuth, setAuth, removeAuth, getUser, setUser} from './AuthHelpers'

type AuthContextProps = {
  auth?: AuthModel
  currentUser?: UserModel
  saveAuth: (auth: AuthModel) => void
  saveUser: (user: UserModel) => void
  logout: () => void
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined)

export const AuthProvider = ({children}: {children: React.ReactNode}) => {
  // 🔥 LOAD FROM LOCAL STORAGE ON REFRESH
  const [auth, setAuthState] = useState<AuthModel | undefined>(getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>(getUser())

  const saveAuthData = (auth: AuthModel) => {
    setAuth(auth)
    setAuthState(auth)
  }

  const saveUserData = (user: UserModel) => {
    setUser(user)
    setCurrentUser(user)
  }

  const logout = () => {
    removeAuth()
    setAuthState(undefined)
    setCurrentUser(undefined)
  }

  return (
    <AuthContext.Provider
      value={{
        auth,
        currentUser,
        saveAuth: saveAuthData,
        saveUser: saveUserData,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}
